module.exports = __webpack_public_path__ + "static/media/guardians-active.72b0424d.svg";